import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Games.css';

const categories = [
  { key: 'marketing', label: 'Marketing', ideal: 600 },
  { key: 'operations', label: 'Operations', ideal: 900 },
  { key: 'product', label: 'Product', ideal: 1200 },
  { key: 'savings', label: 'Emergency Savings', ideal: 300 },
];

const totalBudget = 3000;

const BudgetBuilderGame = () => {
  const [values, setValues] = useState({
    marketing: 0,
    operations: 0,
    product: 0,
    savings: 0,
  });
  const [submitted, setSubmitted] = useState(false);

  const used = useMemo(
    () => Object.values(values).reduce((sum, val) => sum + Number(val || 0), 0),
    [values]
  );

  const remaining = totalBudget - used;

  const score = useMemo(() => {
    if (!submitted) return 0;

    let points = 0;
    categories.forEach((item) => {
      const diff = Math.abs(Number(values[item.key] || 0) - item.ideal);
      if (diff <= 100) points += 25;
      else if (diff <= 250) points += 15;
      else points += 5;
    });

    if (remaining === 0) points += 20;
    return points;
  }, [submitted, values, remaining]);

  const onChange = (key, nextValue) => {
    setValues((prev) => ({
      ...prev,
      [key]: Number(nextValue),
    }));
    setSubmitted(false);
  };

  const reset = () => {
    setValues({ marketing: 0, operations: 0, product: 0, savings: 0 });
    setSubmitted(false);
  };

  return (
    <main className="game-shell">
      <header className="game-header">
        <h1>Budget Builder</h1>
        <p>Allocate ${totalBudget} across your startup plan.</p>
      </header>

      <section className="game-card">
        {categories.map((item) => (
          <div className="budget-row" key={item.key}>
            <label htmlFor={item.key}>{item.label}</label>
            <input
              id={item.key}
              type="number"
              min="0"
              value={values[item.key]}
              onChange={(event) => onChange(item.key, event.target.value)}
            />
          </div>
        ))}

        <p>Used: ${used}</p>
        <p>Remaining: ${remaining}</p>

        <div className="game-row">
          <button type="button" className="game-btn" onClick={() => setSubmitted(true)}>
            Submit Budget
          </button>
          <button type="button" className="game-btn muted" onClick={reset}>
            Reset
          </button>
        </div>

        {submitted && (
          <div className="game-feedback">
            <p>Your score: {score} / 120</p>
            <p>A balanced budget should protect operations while leaving room for growth and emergency cushion.</p>
          </div>
        )}

        <Link to="/games" className="game-link">Back to Games</Link>
      </section>
    </main>
  );
};

export default BudgetBuilderGame;
